import WhatMovesUs from "@/pages/whatMovesUs";
import { createPublicSsrPage } from "../../src/vike/createPublicSsrPage";
import { PATHS } from "../../src/shared/publicPaths";

export default createPublicSsrPage({
  pathname: PATHS.about,
  overrideKey: "whatMovesUs",
  element: <WhatMovesUs />,
});
